export function useCartPopup() {
  var lastAddedItems = useState('useCartPopup-lastItems', function () {
    return [];
  });
  return {
    resetLastAddedItems: function resetLastAddedItems() {
      lastAddedItems.value = [];
    },
    addLastItem: function addLastItem(item) {
      lastAddedItems.value.push(item);
    },
    lastAddedItems: readonly(lastAddedItems)
  };
}